<!-- src/components/RequestService.vue -->
<template>
  <div class="full-screen-background">
    <v-container class="pa-4 fill-height d-flex flex-column justify-center">
      <!-- Título -->
      <h2 class="text-center mb-6">{{ t('service.title') }}</h2>

      <v-card max-width="600" class="mx-auto pa-4 background">
        <!-- Grupo de rádios para selecionar serviço -->
        <v-radio-group
          v-model="serviceType"
          row
          :label="t('service.selectServiceLabel')"
        >
          <v-radio
            v-for="key in serviceKeys"
            :key="key"
            :label="`${t(`service.options.${key}`)} (${costs[key]} ZP)`"
            :value="key"
          />
        </v-radio-group>

        <!-- Seleção de personagem somente para troca de nome -->
        <v-select
          v-if="serviceType === 'changeCharacterName'"
          v-model="form.characterId"
          :items="characters"
          item-title="given_name"
          item-value="id"
          :label="t('service.selectCharLabel')"
          required
          class="mt-4"
        />

        <!-- Campo “Novo Nome do Personagem” -->
        <v-text-field
          v-if="serviceType === 'changeCharacterName'"
          v-model="form.newName"
          :label="t('service.newCharacterNameLabel')"
          required
          class="mt-4"
        />

        <!-- Campo “ID do Item Perdido” -->
        <v-text-field
          v-if="serviceType === 'recoverItem'"
          v-model="form.itemId"
          :label="t('service.lostItemIdLabel')"
          required
          class="mt-4"
        />

        <!-- Campo “Novo Nome da Guilda” -->
        <v-text-field
          v-if="serviceType === 'changeGuildName'"
          v-model="form.newGuildName"
          :label="t('service.newGuildNameLabel')"
          required
          class="mt-4"
        />

        <!-- Campo “Nome do Personagem Deletado” -->
        <v-text-field
          v-if="serviceType === 'recoverDeletedChar'"
          v-model="form.charName"
          :label="t('service.deletedCharNameLabel')"
          required
          class="mt-4"
        />

        <!-- Botão “Solicitar” -->
        <v-btn
          class="mt-6 button"
          color="#5c3e62"
          :loading="sending"
          :disabled="!serviceType"
          @click="onSubmit"
        >
          {{ t('service.buttonRequest') }}
        </v-btn>
      </v-card>
    </v-container>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { fetchCharacters, requestService } from '@/services/api.js'
import { auth } from '@/auth'
import { useRouter } from 'vue-router'

const { t } = useI18n()
const router = useRouter()

// Chaves de serviço (usadas para gerar labels traduzidas)
const serviceKeys = [
  'changeCharacterName',
  'recoverItem',
  'changeGuildName',
  'recoverDeletedChar'
]

// Custos por serviço (permanece em ZP)
const costs = {
  changeCharacterName: 100,
  recoverItem: 50,
  changeGuildName: 150,
  recoverDeletedChar: 200
}

const serviceType = ref('')
const form = reactive({
  characterId: '',
  newName: '',
  itemId: '',
  newGuildName: '',
  charName: ''
})
const characters = ref([])
const sending = ref(false)

// Carrega lista de personagens do usuário
onMounted(async () => {
  try {
    const res = await fetchCharacters(auth.token)
    if (res.characters) {
      characters.value = res.characters
    } else {
      console.error(res.error || 'Erro ao carregar personagens')
    }
  } catch (e) {
    console.error('Falha ao carregar personagens:', e)
  }
})

async function onSubmit() {
  sending.value = true
  try {
    const token = localStorage.getItem('jwt_token')
    if (!token) throw new Error(t('service.errors.notAuthenticated'))

    const data = {}
    switch (serviceType.value) {
      case 'changeCharacterName':
        if (!form.characterId || !form.newName) {
          throw new Error(t('service.errors.selectCharAndName'))
        }
        data.characterId = form.characterId
        data.newName = form.newName
        break

      case 'recoverItem':
        if (!form.itemId) {
          throw new Error(t('service.errors.informItemId'))
        }
        data.itemId = form.itemId
        break

      case 'changeGuildName':
        if (!form.newGuildName) {
          throw new Error(t('service.errors.informNewGuildName'))
        }
        data.newGuildName = form.newGuildName
        break

      case 'recoverDeletedChar':
        if (!form.charName) {
          throw new Error(t('service.errors.informDeletedCharName'))
        }
        data.charName = form.charName
        break
    }

    await requestService(token, serviceType.value, data)
    alert(t('service.success'))
    router.push('/')
  } catch (err) {
    console.error(err)
    alert(err.message)
  } finally {
    sending.value = false
  }
}
</script>

<style scoped>
.full-screen-background {
  background-image: url('@/assets/background/fundotrocasenha.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  width: 100%;
}
.background {
  background-color: rgba(0, 0, 0, 0.514);
}
.button {
  position: relative;
  align-items: center;
  margin-left: 35%;
}
</style>
